import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";
import { CustomerDetailsModel } from "../../../../../../models/customers/customer.models";
import { MepAbout } from "../../tabs/mep-home/tabs/mep-about/mep-about";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";

@autoinject
export class PrintMepHomeDialog {

    model: MepAbout;
    sectionPortDescription: boolean = true;
    sectionPortMap: boolean = true;
    sectionPortTerminology: boolean = false;
    customerDetails: CustomerDetailsModel;
    canViewPortTerminology: boolean;

    constructor(private dialogClientService: DialogClientService,
                private userClaimsService: UserClaimsService) {}

    activate(model: MepAbout){
        this.model = model;
        this.customerDetails = CustomerDetailsModel.getCustomerDetailModelFromRSUser(window["rightshipUser"]);
        this.canViewPortTerminology = this.userClaimsService.hasPermission(Claims.CanViewPortTerminology);
        this.sectionPortTerminology = this.canViewPortTerminology;
    }

    attached() {
        this.model.initializeMapPrint();
        this.model.togglePolygons(this.model.mapPrint);
        this.model.togglePointsOfInterest(this.model.mapPrint);

        //Satellite view
        if (!this.model.showMapView) {
            this.model.satelliteLayer.addTo(this.model.mapPrint);
            this.model.mapLayer.removeFrom(this.model.mapPrint);
        }
    }

    close() {
        this.dialogClientService.hide();
    }

    printDocument() {
        //If the current user is a customer with a trial account
        if(this.customerDetails?.isMepTrial) {
            this.dialogClientService.show(RightShipDialogServiceConstants.URLs.TrialVersionDialog, {customerId: this.customerDetails.customerId, title: 'Print Report'});
        }
        else {
            $(".document-mep-home").printThis({
                importCSS: true,
                importStyle: true,
                loadCSS: "/styles/core.min.css",
                canvas: true
            });
        }
    }
}